@use '~/theme/theme' as *;

.menu {
  display: flex;
  flex-direction: column;

  @include border-radius(sm);
  @include shadow(md);

  outline: 0;
  outline-color: transparent;
  min-width: 220px;
  overflow: hidden;
  background-color: white;
  border-radius: var(--border-radius-sm);
}

.menuItem {
  padding: spacing(1.5);
  display: flex;
  flex-direction: row;
  gap: spacing(1.5);
  align-items: center;
  z-index: z-index(menu);
  outline: 0;
  outline-color: transparent;
  cursor: pointer;

  &[data-focus-visible] {
    outline: 2px solid color(violet-600);
    outline-offset: -2px;
  }

  .menu > &:last-child[data-focus-visible] {
    border-bottom-left-radius: var(--border-radius-sm);
    border-bottom-right-radius: var(--border-radius-sm);
  }

  .menu > &:first-child[data-focus-visible] {
    border-top-left-radius: var(--border-radius-sm);
    border-top-right-radius: var(--border-radius-sm);
  }

  .menu > *:last-child > &:last-child[data-focus-visible] {
    border-bottom-left-radius: var(--border-radius-sm);
    border-bottom-right-radius: var(--border-radius-sm);
  }

  .menu > *:first-child > &:first-child[data-focus-visible] {
    border-top-left-radius: var(--border-radius-sm);
    border-top-right-radius: var(--border-radius-sm);
  }

  &:hover {
    background-color: color(violet-100);
  }

  &.loading {
    pointer-events: none;
  }

  &.destructive {
    color: color(lobster-900);
  }

  &[data-disabled] {
    &:not(.loading) {
      color: color(grey-500);
      background-color: unset;
      cursor: none;
      pointer-events: none;
    }
  }

  .menuItemChildren {
    display: flex;
    flex-direction: column;
    gap: spacing(0.5);
  }
}

.menuItemIcon {
  @include icon-size(sm);

  align-self: flex-start;
}

.menuItem[data-selection-mode='single'] {
  position: relative;
  padding-left: spacing(5);

  &::before {
    content: '';
    position: absolute;
    left: spacing(1.5);
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid color(grey-800);
  }

  &[data-selected]::before {
    border-width: 5px;
  }
}
